import React, { useState, useMemo } from "react";
import {
  FaUsers,
  FaMedkit,
  FaSearch,
  FaRegClipboard,
  FaMoneyCheckAlt,
  FaClipboardList,
  FaEnvelopeOpenText,
} from "react-icons/fa";
import PreviewPopup from "./PreviewPopup";

const VariantDetailsActions = ({
  hasExplicitAccess,
  onAttendanceClick,
  tripGuid,
  variantGuid,
  isCoordinator,
  canCreateRegistration,
  onInsuranceClick,
  onBulkCorrectionClick,
  onScrollToRegistrations,
  onBulkMailClick,
}) => {
  const baseUrl = process.env.REACT_APP_TRIPS_BASE;
  const [previewOpen, setPreviewOpen] = useState(false);

  const previewUrl = useMemo(() => {
    if (!baseUrl || !tripGuid || !variantGuid) return "";
    return `${baseUrl}/${tripGuid}/${variantGuid}`;
  }, [baseUrl, tripGuid, variantGuid]);

  const handleManualRegistrationClick = () => {
    if (baseUrl && variantGuid) {
      window.open(`${baseUrl}/register/${variantGuid}`, "_blank", "noopener,noreferrer");
    }
  };

  const actions = useMemo(() => {
    return [
      {
        key: "registrations",
        label: "Rejestracje",
        icon: FaClipboardList,
        onClick: onScrollToRegistrations,
        visible: true,
      },
      {
        key: "participants",
        label: "Osoby",
        icon: FaUsers,
        onClick: onAttendanceClick,
        visible: !!hasExplicitAccess,
      },
      {
        key: "insurances",
        label: "Ubezp. tur.",
        icon: FaMedkit,
        onClick: onInsuranceClick,
        visible: !!hasExplicitAccess,
      },
      {
        key: "preview",
        label: "Podgląd",
        icon: FaSearch,
        onClick: () => setPreviewOpen(true),
        visible: true,
      },
      {
        key: "manualRegistration",
        label: "Utwórz rezerwację",
        icon: FaRegClipboard,
        onClick: handleManualRegistrationClick,
        visible: !!hasExplicitAccess && !!isCoordinator,
        disabled: !canCreateRegistration,
        title: !canCreateRegistration ? "Wycieczka nie została jeszcze opublikowana" : "",
      },
      {
        key: "bulkCorrection",
        label: "Korekta zbiorcza",
        icon: FaMoneyCheckAlt,
        onClick: onBulkCorrectionClick,
        visible: !!hasExplicitAccess,
      },
      {
        key: "bulkMail",
        label: "Wysyłka maili",
        icon: FaEnvelopeOpenText,
        onClick: onBulkMailClick,
        visible: !!hasExplicitAccess,
      },
    ];
  }, [
    hasExplicitAccess,
    isCoordinator,
    canCreateRegistration,
    onScrollToRegistrations,
    onAttendanceClick,
    onInsuranceClick,
    onBulkCorrectionClick,
    onBulkMailClick,
  ]);

  const visibleActions = actions.filter((a) => a.visible);

  return (
    <>
      <div className="trip-details-buttons">
        {visibleActions.map((a) => {
          const Icon = a.icon;
          const isDisabled = !!a.disabled;

          return (
            <div
              key={a.key}
              className={`trip-details-button-container ${isDisabled ? "disabled" : ""}`}
              onClick={isDisabled ? undefined : a.onClick}
              title={a.title || ""}
              style={isDisabled ? { pointerEvents: "auto" } : undefined}
            >
              <div className="trip-details-button">
                <Icon className="trip-details-button-icon" />
              </div>
              <span className="trip-details-button-label">{a.label}</span>
            </div>
          );
        })}
      </div>

      {previewOpen && (
        <PreviewPopup
          url={previewUrl}
          title="Podgląd wariantu"
          onClose={() => setPreviewOpen(false)}
        />
      )}
    </>
  );
};

export default VariantDetailsActions;
